import React from 'react';
import { CheckCircle2, XCircle, Info, X } from 'lucide-react';
import type { ToastItem } from '../../../context/ToastContext';

interface ToneSpec {
  iconWrap: string;
  Icon: React.ComponentType<{ className?: string }>;
}

const TONE: Record<ToastItem['level'], ToneSpec> = {
  success: {
    iconWrap: 'bg-emerald-100 text-emerald-700',
    Icon: CheckCircle2,
  },
  error: {
    iconWrap: 'bg-rose-100 text-rose-700',
    Icon: XCircle,
  },
  info: {
    iconWrap: 'bg-sky-100 text-sky-700',
    Icon: Info,
  },
};

interface Props {
  toast: ToastItem;
  onDismiss: () => void;
}

const Toast: React.FC<Props> = ({ toast, onDismiss }) => {
  const tone = TONE[toast.level];
  const Icon = tone.Icon;
  return (
    <div
      role="status"
      className="pointer-events-auto flex w-full max-w-sm items-start gap-3 rounded-xl border border-slate-200 bg-white px-4 py-3 shadow-soft animate-slide-in-right"
    >
      <span
        className={`mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full ${tone.iconWrap}`}
        aria-hidden
      >
        <Icon className="h-4 w-4" />
      </span>
      <p className="flex-1 text-sm font-medium text-slate-800">
        {toast.message}
      </p>
      <button
        type="button"
        aria-label="Dismiss"
        className="rounded p-0.5 text-slate-400 hover:bg-slate-100 hover:text-slate-700"
        onClick={onDismiss}
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
};

export default Toast;
